module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/contactIcon_UB.f359ab97.svg";